// tokens
export const retrieveToken = (key = "accessToken") => {
  try {
    const token = localStorage.getItem(key);
    return token || null;
  } catch (error) {
    console.error(`Error retrieving token "${key}":`, error);
    return null;
  }
};

export const storeToken = (key, value) => {
  try {
    localStorage.setItem(key, value);
  } catch (error) {
    console.error(`Error storing token "${key}":`, error);
  }
};

export const removeToken = (key = "accessToken") => {
  try {
    localStorage.removeItem(key);
  } catch (error) {
    console.error(`Error removing token "${key}":`, error);
  }
};

// user
export const storeUser = (user) => {
  try {
    storeToken("user", JSON.stringify(user));
  } catch (error) {
    console.error("Error storing user data:", error);
  }
};

export const getUser = () => {
  try {
    const user = retrieveToken("user");
    return user ? JSON.parse(user) : null;
  } catch (error) {
    console.error("Error retrieving user data:", error);
    return null;
  }
};

// clear all auth-related data
export const clearStorage = () => {
  try {
    // Clear localStorage
    localStorage.clear();

    // Clear sessionStorage
    sessionStorage.clear();

    // Clear cookies
    document.cookie.split(";").forEach((cookie) => {
      const eqPos = cookie.indexOf("=");
      const name = eqPos > -1 ? cookie.substr(0, eqPos) : cookie;
      document.cookie = `${name.trim()}=;expires=Thu, 01 Jan 1970 00:00:00 GMT;path=/`;
    });
  } catch (error) {
    console.error("Error clearing storage:", error);
  }
};

export const getAccessToken = () => localStorage.getItem("accessToken");
